<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  form: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['update']);
const { t } = useI18n();
const update = (field, event) => emit('update', field, event.target.value);
</script>

<template>
  <LaisCard
    :title="t('SALES.DELIVERY.COMMISSION.TITLE')"
    prefix-icon="i-lucide-circle-dollar-sign"
  >
    <div class="grid gap-4 sm:grid-cols-3">
      <LaisField
        :label="t('SALES.DELIVERY.COMMISSION.TOTAL')"
        :error="errors.valor_comissao_total"
        required
      >
        <input
          :value="form.valor_comissao_total"
          class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
          :disabled="disabled"
          @input="update('valor_comissao_total', $event)"
        />
      </LaisField>
      <LaisField
        :label="t('SALES.DELIVERY.COMMISSION.DEDUCTION')"
        :error="errors.deducao"
      >
        <input
          :value="form.deducao"
          class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
          :disabled="disabled"
          @input="update('deducao', $event)"
        />
      </LaisField>
      <LaisField :label="t('SALES.DELIVERY.COMMISSION.NET')">
        <input
          :value="form.valor_comissao_liquida"
          readonly
          class="h-10 w-full rounded-lais-sm border border-lais-border bg-lais-bg-soft px-3 text-sm"
        />
      </LaisField>
    </div>
  </LaisCard>
</template>
